module.exports = __webpack_public_path__ + "img/page_32.8aef606c.png";